"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./StatusBox.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var StatusBox = function StatusBox(_ref) {
  var color = _ref.color,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["color", "className", "children"]);

  var wrapperClass = 'status-box';
  if (color) wrapperClass += " status-box--".concat(color);
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", _extends({
    className: wrapperClass
  }, rest), children);
};

exports.StatusBox = StatusBox;
StatusBox.defaultProps = {
  color: ''
};
StatusBox.propTypes = {
  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Cor da borda esquerda da caixa */
  color: _propTypes.default.string,

  /** HTML ou texto que será renderizado dentro do Well */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = StatusBox;
exports.default = _default;